import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditOrgStructureAssignment from '../../components/orgStructureAssignments/FormAddEditOrgStructureAssignment';
import { useParams } from 'react-router-dom';
import { useGetOrgStructureAssignment } from '../../hooks/orgStructureAssignments/useGetOrgStructureAssignment';
import LoadingPage from '../../components/global/LoadingPage';

const EditOrgStructureAssignment = () => {
    const { id } = useParams();
    const { assignment, isLoading } = useGetOrgStructureAssignment(id);
    if (isLoading) return <LoadingPage />;
    return (<WrapperSection><GlobalBreadcrumbs /><FormAddEditOrgStructureAssignment isEdit currentData={assignment?.data} /></WrapperSection>);
};
export default EditOrgStructureAssignment;
